import { initializeApollo } from '@/graphql/client';
import type {
  UserDetailsQuery,
  UserDetailsQueryVariables,
  UserFragment,
} from '@/graphql/saleor/api';
import { UserDetailsDocument } from '@/graphql/saleor/api';
import { userState } from '@/states/user';

let inflightUserFetch: Promise<UserFragment | null> | null = null;

export const userFetch = async (
  refresh = false,
): Promise<UserFragment | null> => {
  if (userState.user && !refresh) {
    return userState.user as UserFragment;
  }

  if (!refresh && inflightUserFetch) {
    return inflightUserFetch;
  }

  const client = initializeApollo();
  const request = client
    .query<UserDetailsQuery, UserDetailsQueryVariables>({
      query: UserDetailsDocument,
      fetchPolicy: 'no-cache',
    })
    .then(({ data }) => data?.me ?? null);

  if (!refresh) {
    inflightUserFetch = request;
    const clearInflightUserFetch = () => {
      if (inflightUserFetch === request) {
        inflightUserFetch = null;
      }
    };
    void request.then(clearInflightUserFetch, clearInflightUserFetch);
  }

  return request;
};
